Ext.define('SA.controller.ImportTermsController', {
    alias: 'controller.import-terms-controller',

    constructor() {
        if (!SA.User.didAgreeToImportTerms()) {
            this.showWin();
            return;
        }

        this.beginPrepareImport();
    },

    beginPrepareImport() {
        Ext.createByAlias('controller.prepare-import-controller');
    },

    onClickAgree() {
        SA.User.setDidAgreeToImportTerms();

        this.win.destroy();
        this.beginPrepareImport();
    },

    showWin() {
        this.win = Ext.widget({xtype: 'import-terms-window'});

        this.win.on('click:agree', () => this.onClickAgree());
        this.win.on('click:cancel', () => this.win.destroy());
    }
});